export const UserProfilePageHeaderInhabitantInfoItemName = {
  ExternalId: 'externalId',
  Role: 'role',
}

export const USER_PROFILE_PAGE_HEADER_INHABITANT_EDIT_ROLE_PAYLOAD_KEY = 'role'

export const USER_PROFILE_PAGE_HEADER_INHABITANT_EDIT_EXTERNAL_ID_FIELD_NAME =
  'external_id'

export const USER_PROFILE_PAGE_HEADER_INHABITANT_EDIT_EXTERNAL_ID_MODAL_QA_NAME =
  'EditExternalId'

export const USER_PROFILE_PAGE_HEADER_INHABITANT_INFO_ITEMS_LOADING_ITEMS_LENGTH = 3

export const USER_PROFILE_PAGE_HEADER_INHABITANT_INFO_ITEM_ACTION_QA_NAMES = {
  [UserProfilePageHeaderInhabitantInfoItemName.ExternalId]: {
    add: 'userProfileHeaderExternalIdAddBtn',
    edit: 'userProfileHeaderExternalIdEditBtn',
  },
  [UserProfilePageHeaderInhabitantInfoItemName.Role]: {
    edit: 'userProfileHeaderRoleEditBtn',
  },
}
